import AppHeader from "../../layout/AppHeader";
import ScheduleAway from '../../xpost/views/umov/schedule.away/ScheduleAway.vue';
import ScheduleAwayAdd from '../../xpost/views/umov/schedule.away/ScheduleAwayAdd.vue';

const ScheduleAwayRoutes = [
  {
    path: "/cadastro/ausencia",
    name: "schedule.away",
    components: {
      header: AppHeader,
      default: ScheduleAway,
    }
  },
  {
    path: "/cadastro/ausencia/adicionar",
    name: "schedule.away.add",
    components: {
      header: AppHeader,
      default: ScheduleAwayAdd,
    }
  },
  {
    path: "/cadastro/ausencia/editar/:id",
    name: "schedule.away.edit",
    components: {
      header: AppHeader,
      default: ScheduleAwayAdd,
    }
  },
]

export default ScheduleAwayRoutes;